<template>
  <div class="@container break-inside-avoid">
    <div
      class="bg-surface-container-low print:border-outline-variant rounded-medium last:rounded-b-large grid grid-cols-1 p-4 @2xl:grid-cols-2 @2xl:gap-10 @2xl:p-6 print:border print:bg-transparent print:bg-none"
    >
      <div>
        <span v-if="data.question.groupTitle" class="text-primary mb-4 flex items-center gap-2">
          <BaseIcon filled>{{ data.question.groupIcon }}</BaseIcon>
          <span class="text-title-medium md:text-title-large lg:text-headline-medium">{{
            data.question.groupTitle
          }}</span>
        </span>
        <h4
          class="mb-2 text-balance"
          :class="[
            data.question.groupTitle &&
              'text-title-medium print:text-title-medium @2xl:text-title-large text-on-surface-variant',
            !data.question.groupTitle &&
              'text-title-large print:text-title-large @2xl:text-headline-medium',
          ]"
        >
          {{ data.question.content }}
        </h4>
      </div>
      <HistogramChart
        :scale="data.scale"
        :perspectives="data.perspectives"
        :all-perspectives="topicPerspectives"
        :disable-animation="disableAnimation"
        :show-self-feedback="showSelfFeedback"
      />
    </div>
  </div>
</template>
<script lang="ts" setup>
  import type { PulseQuestionAnalysis } from '@/core/models/surveys-analytics'
  import type { Perspective } from '@/core/models/perspective'
  import HistogramChart from '../histogram/HistogramChart.vue'
  import BaseIcon from '../../base/icon/BaseIcon.vue'

  interface Props {
    data: PulseQuestionAnalysis
    topicPerspectives: ReadonlyArray<Perspective>
    disableAnimation?: boolean
    /** When true, self is drawn as a bar series. Defaults to false. */
    showSelfFeedback?: boolean
  }

  withDefaults(defineProps<Props>(), {
    showSelfFeedback: false,
  })
</script>
